import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Variant } from '../../../models/product/dto/variant';
import { ProductSectionItemExpandedProductInfoViewModel } from '../../display/components/menus/product-menu/building-blocks/menu-item/product-section-item-expanded-product-info/product-section-item-expanded-product-info-view-model';

@Pipe({
  name: 'getProductSectionItemExpandedProductInfoExpandedGridSize',
  standalone: false
})
export class GetProductSectionItemExpandedProductInfoExpandedGridSizePipe implements PipeTransform {
  transform(
    viewModel: ProductSectionItemExpandedProductInfoViewModel,
    variant: Variant,
    spacesBetweenX: boolean = true,
    removeSpacing: boolean = true,
    upperCaseUnits: boolean = true
  ): Observable<string | null> {
    const expandedGridSize$ = viewModel
      ?.getExpandedGridSize$(variant, removeSpacing, upperCaseUnits)
      ?.pipe(map(size => (spacesBetweenX ? size?.replace('x', ' x ') : size)));
    return expandedGridSize$ || of(null);
  }
}
